import _ from 'lodash'
import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

export default {
  id: 'mix2',
  name: 'mix2',
  type: 'standard',
  moduleName: 'editor_module_mix2',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius', 'padding'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          color: _.cloneDeep(columnDetail.text),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius),
          padding: _.cloneDeep(columnDetail.padding)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'image',
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          color: _.cloneDeep(columnDetail.text),
          upload: _.cloneDeep(columnDetail.upload)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'image',
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload)
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
